import React from 'react';
import PropTypes from 'prop-types';

const SingleJoinSVGR = ({ className }) => (
  <svg
    width='48'
    height='48'
    viewBox='0 0 48 48'
    className={className}
  >
    <path
      fill='#19a683'
      d='M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z'
      opacity='0.33'
    />
    <path
      fill='#00604b'
      d='M26.877 26.25A8.124 8.124 0 0135 34.374c0 .9-.727 1.626-1.627 1.626H15.625A1.625 1.625 0 0114 34.374a8.123 8.123 0 018.123-8.124zM18.5 18a6 6 0 1112 0 6 6 0 01-12 0z'
    />
  </svg>
);

SingleJoinSVGR.propTypes = {
  className: PropTypes.string,
};

SingleJoinSVGR.defaultProps = {
  className: '',
};

export default SingleJoinSVGR;
